"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var api_1 = __importDefault(require("../providers/api"));
var errors_1 = require("../errors");
;
var handleError = function (throwError) { return function (err) {
    if (err.response && err.response.status === 403) {
        return Promise.reject(new errors_1.CoreError({
            code: err.data.meta.code,
            message: err.data.meta.message,
            type: 'authorization',
        }));
    }
    if (throwError) {
        return Promise.reject(err.data.meta);
    }
    return Promise.resolve([]);
}; };
exports.CarsApiAdapter = function (baseUrl, apiProvider) {
    if (apiProvider === void 0) { apiProvider = new api_1.default(); }
    return {
        getMakes: function () {
            return apiProvider
                .get(baseUrl + "/makes")
                .then(function (_a) {
                var data = _a.data;
                return data.body;
            })
                .catch(handleError(false));
        },
        getModels: function (car) {
            return apiProvider
                .get(baseUrl + "/models?make=" + car.make.toUpperCase())
                .then(function (_a) {
                var data = _a.data;
                return data.body;
            })
                .catch(handleError(false));
        },
        getYears: function (car) {
            return apiProvider
                .get(baseUrl + "/years?make=" + car.make.toUpperCase() + "&model=" + car.model.toUpperCase())
                .then(function (_a) {
                var data = _a.data;
                return data.body;
            })
                .catch(handleError(false));
        },
        getVersions: function (car) {
            return apiProvider
                .get(baseUrl + "/versions?make=" + car.make.toUpperCase() + "&model=" + car.model.toUpperCase() + "&year=" + car.year)
                .then(function (_a) {
                var data = _a.data;
                return data.body;
            })
                .catch(handleError(false));
        },
        addVersion: function (car) {
            car.make = car.make.toUpperCase();
            car.model = car.model.toUpperCase();
            car.version = car.version.toUpperCase();
            return apiProvider
                .post(baseUrl + "/versions", {
                body: car
            })
                .then(function (_a) {
                var data = _a.data;
                return data.body;
            })
                .catch(handleError(true));
        },
        updateVersion: function (car, newVersion) {
            car.make = car.make.toUpperCase();
            car.model = car.model.toUpperCase();
            car.version = car.version.toUpperCase();
            newVersion = newVersion.toUpperCase();
            return apiProvider
                .put(baseUrl + "/versions", {
                body: __assign({}, car, { newVersion: newVersion }),
            })
                .then(function (_a) {
                var data = _a.data;
                return data.body;
            })
                .catch(handleError(true));
        },
        removeVersion: function (car) {
            car.make = car.make.toUpperCase();
            car.model = car.model.toUpperCase();
            car.version = car.version.toUpperCase();
            return apiProvider
                .delete(baseUrl + "/versions?make=" + car.make + "&model=" + car.model + "&year=" + car.year + "&version=" + car.version)
                .then(function (_a) {
                var data = _a.data;
                return data.body;
            })
                .catch(handleError(true));
        }
    };
};
//# sourceMappingURL=data:application/json;base64,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


//////////////////
// WEBPACK FOOTER
// ../@core/dist/adapters/cars.js
// module id = 884
// module chunks = 0